import { render, staticRenderFns } from "./myCouponsList.vue?vue&type=template&id=158f1fea&scoped=true"
import script from "./myCouponsList.vue?vue&type=script&lang=js"
export * from "./myCouponsList.vue?vue&type=script&lang=js"
import style0 from "./myCouponsList.vue?vue&type=style&index=0&id=158f1fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f1fea",
  null
  
)

export default component.exports